(() => {
  const submittedKey = 'newent_wholesale_application_submitted_v2';
  const pendingKey = 'newent_wholesale_application_pending_v2';
  const noticeLifetime = 24 * 60 * 60 * 1000;

  const gate = document.querySelector('[data-newent-wholesale-gate]');
  if (!gate) return;

  const status = gate.dataset.status || 'guest';
  const signupUrl = gate.dataset.signupUrl || '/pages/wholesale-signup';
  const loginUrl = gate.dataset.loginUrl || '/account/login';
  const isRegistrationPage = gate.dataset.registrationPage === 'true';

  document.documentElement.dataset.wholesaleStatus = status;

  const setStoredTime = (key) => {
    try {
      localStorage.setItem(key, String(Date.now()));
    } catch (error) {}
  };

  const getStoredTime = (key) => {
    try {
      return Number(localStorage.getItem(key) || 0);
    } catch (error) {
      return 0;
    }
  };

  const removeStoredTime = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {}
  };

  const updateLinks = () => {
    document.querySelectorAll('[data-wholesale-guest-link]').forEach((link) => {
      link.setAttribute('href', signupUrl);
    });

    document.querySelectorAll('[data-wholesale-login-link]').forEach((link) => {
      link.setAttribute('href', loginUrl);
    });

    document.querySelectorAll('[data-wholesale-guest-label]').forEach((label) => {
      label.textContent = 'Apply for Wholesale Access';
    });
  };

  const showApplicationNotice = () => {
    if (status !== 'guest') return;
    const submittedAt = getStoredTime(submittedKey);
    if (!submittedAt || Date.now() - submittedAt > noticeLifetime) {
      removeStoredTime(submittedKey);
      return;
    }

    const notice = document.querySelector('[data-wholesale-application-notice]');
    if (notice) notice.hidden = false;
  };

  const markApplicationSubmitted = () => {
    setStoredTime(submittedKey);
    removeStoredTime(pendingKey);
    showApplicationNotice();
  };

  const hasSuccessState = () => {
    const bodyText = document.body ? document.body.innerText.toLowerCase() : '';
    return /registration (has been )?(submitted|successful)|application (has been )?(submitted|successful)|thank you for registering|successfully registered|request (has been )?submitted/.test(bodyText);
  };

  const bindRegistrationForm = () => {
    if (!isRegistrationPage) return;

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.matches('form')) return;
      if (
        form.closest('.bss-b2b-registration-form') ||
        form.querySelector('[name="customer[email]"], [name="email"], input[type="email"]')
      ) {
        setStoredTime(pendingKey);
      }
    }, true);

    if (hasSuccessState()) markApplicationSubmitted();

    const observer = new MutationObserver(() => {
      if (hasSuccessState()) {
        markApplicationSubmitted();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const detectCompletedRedirect = () => {
    if (isRegistrationPage) return;

    const pendingAt = getStoredTime(pendingKey);
    if (!pendingAt || Date.now() - pendingAt > 10 * 60 * 1000) {
      removeStoredTime(pendingKey);
      return;
    }

    let cameFromRegistration = false;
    try {
      cameFromRegistration = new URL(document.referrer).pathname === signupUrl;
    } catch (error) {}

    if (cameFromRegistration) markApplicationSubmitted();
  };

  const redirectToApplication = () => {
    const separator = signupUrl.includes('?') ? '&' : '?';
    window.location.assign(signupUrl + separator + 'notice=approval-required');
  };

  const bindCheckoutGate = () => {
    if (status === 'approved') return;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        '[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], form[action="/checkout"] button'
      );
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      redirectToApplication();
    }, true);

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      const form = event.target;
      const isCheckout =
        (submitter && submitter.name === 'checkout') ||
        (form && /\/checkout(?:\?|$)/.test(form.action || ''));

      if (!isCheckout) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      redirectToApplication();
    }, true);
  };

  document.addEventListener('DOMContentLoaded', () => {
    updateLinks();
    bindRegistrationForm();
    detectCompletedRedirect();
    showApplicationNotice();
    bindCheckoutGate();

    document.querySelectorAll('[data-wholesale-dismiss]').forEach((button) => {
      button.addEventListener('click', () => {
        removeStoredTime(submittedKey);
        const notice = button.closest('[data-wholesale-application-notice]');
        if (notice) notice.hidden = true;
      });
    });
  });

  window.NewentWholesaleAccess = {
    status,
    signupUrl,
    loginUrl,
    updateLinks
  };
})();
